import { catchCommonErrors } from 'app/actions/commonActionUtils'
import { getCookieValue } from 'app/actions/genericActionCreator'
import { format } from 'date-fns'

export const fetchingAlertData = () => ({
  type: 'ALERT_FETCHING'
})

export const doneFetchingAlertData = () => ({
  type: 'ALERT_FETCHED'
})

export const deletingAlertData = () => ({
  type: 'ALERT_DELETING'
})

export const deleteAlertData = () => ({
  type: 'ALERT_DELETED'
})

export const savingAlertData = () => ({
  type: 'ALERT_SAVING'
})

export const doneSavingAlertData = (alert) => ({
  type: 'ALERT_SAVED',
  alert
})

export const recievedFetchingAlertData = (alert) => ({
  type: 'ALERT_CHANGED',
  alert
})

export const fetchLatestAlertData = () => (dispatch, getState) => {
  /* Do not want to use the protected URL because that would keep the session alive which is against AccessVA rules.
   * We use the relative URL on the first request because it happens just once at page load so doesn't keep session alive. 
   * We don't use the public URL on the first request because we likely haven't gotten the server properties yet that tell
   * us the public URL.
   */
  const state = getState()
  const alertUrl = state.serverProperties.lgyUrl && !state.serverProperties.lgyUrl.startsWith('https://local') ?
    `${state.serverProperties.lgyUrl}/lgyhub/api/alert` : '/lgyhub/api/alert'
  dispatch(fetchingAlertData())
  fetch(`${alertUrl}`, { credentials: 'include' })
    .then((response) => {
      return catchCommonErrors(dispatch, response, 'fetching alerts')
    }).then((newAlert) => {
      dispatch(doneFetchingAlertData())
      const alertDidChange = newAlert.id !== state.alert.id || newAlert.type !== state.alert.type
        || newAlert.headline !== state.alert.headline || newAlert.byline !== state.alert.byline
        || newAlert.endTime !== state.alert.endTime
      const alertWasDeleted = !(!!newAlert.id) && !!state.alert.id
      if (alertWasDeleted) {
        dispatch(deleteAlertData())
      } else if (alertDidChange) {
        dispatch(recievedFetchingAlertData(newAlert))
      } // else no change
    }).catch((error) => {
      console.error('There has been a problem with fetching alerts: ', error)
    })
}

export const deleteAlert = (id) => dispatch => {
  dispatch(deletingAlertData())
  fetch(`/lgyhub/api/alert/delete/${id}`, {
    credentials: 'include',
    method: 'POST', //should be 'delete' but firewall blocks 'delete' 
    headers: new Headers({
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
    })
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Network response was not okay.')
    }
  }).then(() => {
    dispatch(deleteAlertData())
  }).catch((error) => {
    console.error('There has been a problem deleting alert: ', error)
  })
}

export const saveAlert = (id, type, headline, byline, end) => dispatch => {
  dispatch(savingAlertData())
  dispatch(recievedFetchingAlertData({ id, type, headline, byline, end }))
  let url = !!id ? `/lgyhub/api/alert/save/${id}` : '/lgyhub/api/alert/save'
  fetch(url, {
    credentials: 'include',
    method: 'POST', //should be 'put' but firewall blocks 'put'
    body: JSON.stringify({
      type: type,
      headline: headline,
      byline: byline,
      endTime: end ? format(end, 'yyyy-MM-dd HH:mm:ss.SSS', { awareOfUnicodeTokens: true }) : ''
    }),
    headers: new Headers({
      'Content-Type': 'application/json',
      'X-XSRF-TOKEN': getCookieValue('XSRF-TOKEN')
    })
  }).then((response) => {
    return catchCommonErrors(dispatch, response, 'saving this alert')
  }).then((responseJson) => {
    dispatch(doneSavingAlertData(responseJson))
  }).catch((error) => {
    console.error('There has been a problem saving alert: ', error)
  })
}
